import React, { useState, useEffect } from "react";
import Navbar from "../Components/Navbar";
import img from "../Assets/Listitem.png";
// import p1 from "../Assets/img1.png";
import Footer from "../Components/Footer";
import { getOurTeam } from "../Common/apis.js";
import Loader from "../Loader/Loader.jsx";
import Aos from "aos";
import founder from '../Assets/sahil (1).png'
import { Link } from "react-router-dom";
const ourList = [
  {
    name: "Sarah Aileah",
    placement: "Chief Creative Officer",
    profile: "/assets/home/profile1.png",
    id: 1
  },
  {
    name: "Jonathan Leon",
    placement: "Chief Talent Officer",
    profile: "/assets/home/profile2.png",
    id: 2
  },
  {
    name: "Sarah Aileah",
    placement: "Chief Creative Officer",
    profile: "/assets/home/profile1.png",
    id: 3
  },
  {
    name: "Jonathan Leon",
    placement: "Chief Talent Officer",
    profile: "/assets/home/profile2.png",
    id: 4
  }
];

function Home() {
  useEffect(() => {
          Aos.init({
            duration: 1000, // animation duration in ms
            once: true,     // animate only once
          });
        }, []);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);


  useEffect(()=>{
    const fetchOurTeam = async () => {
      try {
        const response = await getOurTeam();
        setData(response.data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchOurTeam();
  },[])

  console.log(data)
  return (
    <div className="main-div">
      <Navbar />
      {loading && <Loader />}
      <div className="sm:px-[58px] px-[20px] sm:pt-[141px] pt-[80px]">
        <div className="home-founders">
          <div className="home-founders-left">
                  <h3
            data-aos="fade-left"
              style={{
                fontFamily: "DM Serif Text, serif",
                letterSpacing: "-0.32px"
              }}
              className="meet-text"
            >
              <i>Meet Our <span style={{color:'#6953A3'}}>Founder</span></i>
            </h3>
            {/* <h3
            data-aos="fade-right"
              style={{
                fontFamily: "DM Serif Text, serif",
                letterSpacing: "-0.32px"
              }}
              className="founder-text"
            >
              <i></i>
            </h3> */}
          <div className="founder-info">
<img src={founder}/>
<div className="get-in-touch">
<Link to='https://www.instagram.com/iamsssaahhiill/'>

<i class="bi bi-instagram"></i>
</Link>
<Link to='https://www.linkedin.com/in/sahilgoyal-ai/'>

<i class="bi bi-linkedin"></i>
</Link>

</div>
<div className="get-in-touch2">
<h3>Sahil Goyal</h3>
</div>
          </div>
            {/* <img data-aos="flip-up" src={img} alt="as" /> */}
     
             
          </div>
          {/* <div className="home-founders-right">
         
            <img data-aos="flip-up" src={img} alt="sdf" />
          </div> */}
        </div>
        {/* <div className="flex smm:justify-end justify-center pt-[50px] pb-[27px]">
          <div className="more-btn flex flex-col justify-center gap-[4px] items-center">
            <p
              style={{ fontFamily: "DM sans, serif" }}
              className="font-[500] max-w-[79px] w-full text-[15px] leading-[15px] text-center text-[#263238]"
            >
              Get To Know More
            </p>
            <img src="/assets/home/right-arrow.svg" alt="" />
          </div>
        </div> */}
      </div>
      <br />
      <br />
      {/* <div className="OurCoreTeam">
        <h3
          style={{
            fontFamily: "DM Serif Text, serif",
            letterSpacing: "-0.32px"
          }}
          className="font-[400] text-center sm:text-[140px] text-[40px] sm:leading-[132px] leading-[40px] text-[#6953A3]"
        >
          <i>Our Core Team</i>
        </h3>
        <div className="sm:px-[100px] overflow-hidden px-[20px] sm:pt-[190px] pt-[105px]">
          <div className="grid sm:grid-cols-4 grid-cols-2 gap-[40px] sm:gap-y-[40px] gap-y-[70px]">
            {data && data?.length>0 && data?.map((e, i) => {
              return (
                <>
                  <div
                    key={i}
                    className="sm:w-[253px] w-[156px] sm:h-[314px] h-[193px] sm:p-[20px] p-[10px] bg-[#FFFFFF]"
                  >
                    <div className="sm:h-[222px] h-[136px] relative sm:w-[212px] w-[130px] bg-[#FAF5F1]">
                      <img
                        src={e?.image}
                        className="absolute bottom-0 overflow-visible object-cover sm:h-[310px] h-[190px] sm:w-[339px] w-[208px]"
                        alt=""
                      />
                    </div>
                    <h6
                      style={{
                        fontFamily: "DM Sans, serif"
                      }}
                      className="font-[700] sm:text-[27px] pt-[6px] text-[16px] sm:leading-[36px] leading-[20.83px] text-center pb-[3px]"
                    >
                      {e?.name}
                    </h6>
                    <p
                      style={{
                        fontFamily: "DM Sans, serif"
                      }}
                      className="font-[400] sm:text-[20px] text-[13px] sm:leading-[26px] leading-[16px] text-center"
                    >
                      {e?.position}
                    </p>
                  </div>
                </>
              );
            })}
          </div>
        </div>
        <div className="sm:px-[100px] overflow-hidden px-[20px] sm:pt-[190px] pt-[105px]">
          <div className="grid sm:grid-cols-4 grid-cols-2 gap-[40px] sm:gap-y-[40px] gap-y-[70px]">
            {ourList?.map((e, i) => {
              return (
                <>
                  <div key={i} className="sm:w-[253px] w-[156px] sm:h-[314px] h-[193px] sm:p-[20px] p-[10px] bg-[#FFFFFF]">
                    <div className="sm:h-[222px] h-[136px] relative sm:w-[212px] w-[130px] bg-[#FAF5F1]">
                      <img
                        src={e?.profile}
                        className="absolute bottom-0 overflow-visible object-cover sm:h-[355px] h-[190px] sm:w-[339px] w-[208px]"
                        alt=""
                      />
                    </div>
                    <h6
                      style={{
                        fontFamily: "DM Sans, serif",
                      }}
                      className="font-[700] sm:text-[27px] pt-[6px] text-[16px] sm:leading-[36px] leading-[20.83px] text-center pb-[3px]"
                    >
                      {e?.name}
                    </h6>
                    <p
                      style={{
                        fontFamily: "DM Sans, serif",
                      }}
                      className="font-[400] sm:text-[20px] text-[13px] sm:leading-[26px] leading-[16px] text-center"
                    >
                      {e?.placement}
                    </p>
                  </div>
                </>
              );
            })}
          </div>
        </div>
        <div className="flex smm:justify-end justify-center pt-[35px] pb-[57px]">
          <div className="more-btn flex flex-col justify-center gap-[4px] items-center">
            <p
              style={{ fontFamily: "DM sans, serif" }}
              className="font-[500] max-w-[79px] w-full text-[15px] leading-[15px] text-center text-[#263238]"
            >
              Get To Know More
            </p>
            <img src="/assets/home/right-arrow.svg" alt="" />
          </div>
        </div>
      </div> */}
      <Footer />
    </div>
  );
}

export default Home;
